import React, {useEffect, useState} from 'react';
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import PropTypes from "prop-types";
import {BackIcon} from "../../../../components/icons/icons";
import IconButton from '@mui/material/IconButton';
import {AgyleListViewIcon} from '../../../../components/icons/agyle';
import useOpenState from '../../../../hooks/useOpenState';
import AgyleDialog from '../../../../components/modal/agyleDialog';

export const useStyles = makeStyles((theme) => ({
    statusItem: {
        width: "50%",
        textAlign: "center",
        color: "grey",
        cursor: "pointer",
        padding: 5,
        fontSize: 12,
        borderBottom: "1px solid "+theme.palette.background.default,
    },
    itemSelected: {
        borderBottom: "1px solid "+theme.palette.primary.main,
        color: "white",
        transition: "border 0.6s linear"
    },
    patientsCounter: {
        fontSize: 12,
        padding: 10
    },
    counter: {
        background: "#3d3e40",
        borderRadius: 7,
        padding: 5,
        width: 25,
        display: "inline",
        textAlign: "center"
    },
    availableCalendarHeader: {
        display: "flex", alignItems: "center", justifyContent: "space-around", marginBottom: 10
    },
    headerDate: {
        fontSize: 24, fontWeight: "bold",
        marginBottom: 10,
        marginLeft: 5,
        marginTop: 24
    },
    headerDateInline: {
        fontSize: 24, fontWeight: "bold",
        marginBottom: 10,
        marginLeft: 5,
        marginTop: 24,
        display: "inline-flex",
        alignItems: "center",
        gap: 10
    },
    rotate: {
        transform: "rotate(-180deg)"
    },
    filterHeader: {
        color: "white",
        minWidth: "260px",
        display: "inline-flex",
        fontSize: "14px",
        background: "#2180F7",
        alignItems: "center",
        alignContent: "center",
        borderRadius: "16px",
        marginLeft: "15px",
        padding: "2px 10px 2px 10px",
        fontWeight: "normal",
        justifyContent: "space-between",
        gap: 15,
        minHeight: 38
    },
    calendarContainer: {
      //  marginRight: 10,
        marginLeft: 55
    },
    sessionItem: {
        background:  theme.palette.bookAdmissions.dcLabelBackground,
        padding: 10,
        marginBottom: 10,
        borderRadius: 6
    },
    sessionLabel: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "10px",
        marginBottom: 5
    },
    sessionDetailsLabel: {
      color: "#ACAFB3",
        marginRight: 5
    },
    sessionDetailsItem: {
      //  width: "25%",
        fontSize: 13
    },
    sessionTime: {
      background: "#ACAFB3",
      color: "black",
      borderRadius: 10,
      fontSize: 10,
        padding: "1px 7px 1px 7px"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb"
    },
    calendarContainerNoPadding: {
      marginLeft: 0
    },
    dayNumber: {
        textAlign: "center",
        marginBottom: "5px",
        marginTop: "5px"
    },
    dayNumberPill: {
        margin: "0 5px 0 5px",
        backgroundColor: theme.palette.mode === "dark" ? "#313233" : "#626466",
        color: "#ffffff",
        borderRadius: "7px",
        padding: "6px 0px"
    },
    selectedDay: {
        color: "white",
        borderRadius: "30px",
        pointerEvents: "none",
        backgroundColor: "#2180F7",
        width: "25px",
        textAlign: "center"
    },
    filteredDay: {
        border: "1px dashed white !important"
    }

}));


const AgyleCalendar = (props) => {

    const classes = useStyles();
    const [selectedDate, setSelectedDate] = React.useState(props.date)
    const [calendar, setCalendar] = React.useState([]);
    const [selectedSessionIndex, setSelectedSessionIndex] = useState(0);

    const weekDays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

    useEffect(()=>{
        setSelectedDate(props.date);
    }, [props.date])

    useEffect(()=>{
        if(props.onDateChange) {
            props.onDateChange(selectedDate)
        }
    }, [selectedDate])

    useEffect(() => {
        createCalendar()
        setSelectedSessionIndex(0)
    }, [props.values])


    useEffect(() => {
        createCalendar();
    }, [selectedDate]);

    useEffect(()=>{
        if(props.selectedDay) {
            setSelectedDate(moment(props.selectedDay, "DD/MM/YYYY").startOf("month"));
        }
    },[props.selectedDay]);

    const createCalendar = () => {
        let startDayTmp = moment(selectedDate);

        const year = startDayTmp.year();
        const month = startDayTmp.month() + 1;

        let calendar = [];

        const date = new Date(year, month - 1, 1);
        let firstDayOfWeek = date.getDay() - 1;
        if (firstDayOfWeek === -1) {
            firstDayOfWeek = 6;
        }

        const daysInMonth = new Date(year, month, 0).getDate();
        const daysInPreviousMonth = new Date(year, month - 1, 0).getDate();

        let day = 1;
        let previousMonthDay = daysInPreviousMonth - firstDayOfWeek + 1;
        let nextMonthDay = 1;


        for (let i = 0; i < 6; i++) {
            calendar[i] = [];
            if (day <= daysInMonth) {
                for (let j = 0; j < 7; j++) {
                    if (i === 0 && j < firstDayOfWeek) {
                        calendar[i][j] = {
                            day: previousMonthDay,
                            actualMonth: false
                        };
                        previousMonthDay++;
                    } else if (day > daysInMonth) {
                        calendar[i][j] = {
                            day: nextMonthDay,
                            actualMonth: false
                        };
                        nextMonthDay++;
                    } else {
                        let fullDay = day < 10? "0"+day: day;
                        let fullMonth = month < 10? "0"+month: month;


                        let dayData = props.values?.filter(val =>
                            val[props.datePath]
                            && moment(val[props.datePath]).format("DD/MM/YYYY") === fullDay+'/'+fullMonth+'/'+year);

                        if(props.selectedDay === (fullDay+'/'+fullMonth+'/'+year) && dayData.length !== 0){
                            props.handleOnClick(null);
                        }

                        calendar[i][j] = {
                            day: day,
                            date: fullDay+'/'+fullMonth+'/'+year,
                            actualMonth: true,
                            dayData: dayData
                        };
                        day++;
                    }
                }
            }
        }

        setCalendar(calendar);
    }



    const handleChangeDate = (direction) => {
        setSelectedDate((date) => moment(date).add(direction, "month"))
    }

    const handleDayClick = (day) => {
        if(props.handleOnClick && day.actualMonth)
            props.handleOnClick(day.date)
    };

    const renderDefaultDayCard = (day) => {
        return <div className={clsx(props.selectedDay === day.date && classes.selectedDay)}>{day.day}</div>
    }


    const dayIsFiltered = (day) => {
        return props.sessionsAreFiltred && props.values[selectedSessionIndex] && moment(props.values[selectedSessionIndex]?.day).format("D") === day+""
    }

    const [isModalFilteredSessionOpen, openFilteredSessionModal, closeFilteredSessionModal] = useOpenState(false, true);

    const renderSessionList = () => {
        return props.values.map((session)=>{
            return props?.renderSessionList ?
              props.renderSessionList(session) :
              <div className={classes.sessionItem}>
                <div className={classes.sessionLabel}>
                    <div> {moment(session.day).format("Do of MMMM ")} </div>
                    <div className={classes.sessionTime}> {session.timeOfDay.code.toUpperCase()} </div>
                </div>
                <Grid container columns={10}>
                    <Grid item xs={2}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Duration </span> {moment(session.day).format("HH:mm")} - {moment(session.day).add(session.maxTime, "minutes").format("HH:mm")}
                        </div>
                    </Grid>
                    <Grid item xs={2}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Surgeon </span> {session.surgeon?.name ?? "-"}
                        </div>
                    </Grid>
                    <Grid item xs={2}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Consultant</span> {session.consultant?.name ?? "-"}
                        </div>
                    </Grid>
                    <Grid item xs={2}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Specialty </span> {session.specialty?.__description ?? "-"}
                        </div>
                    </Grid>
                    <Grid item xs={2}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Anaesthetists </span> {session.anaesthetists?.name ?? "-"}
                        </div>
                    </Grid>
                </Grid>

            </div>
        })
    }
    return(
        <div className={clsx(classes.calendarContainer, props.noPadding && classes.calendarContainerNoPadding)}>

            <AgyleDialog
                title={"Filtered Session List"}
                open={isModalFilteredSessionOpen}
                onClose={closeFilteredSessionModal}
                fullWidth={true}
                closeButtonOnHeader
                onSave={closeFilteredSessionModal}
                width={"l"}
                disableActions
                contentStyle={classes.dialogContentStyle}

            >
               <div>{renderSessionList()}</div>
            </AgyleDialog>

        {props.calendarAvailable &&
            <div className={classes.availableCalendarHeader}>
                <IconButton onClick={(e) => handleChangeDate(-1)}>
                    <BackIcon/>
                </IconButton>

                <div className={clsx(classes.headerDate, props?.headerDateStyles)}> {moment(selectedDate).format("MMMM YYYY")} </div>

                <IconButton onClick={(e) => handleChangeDate(1)}>
                    <BackIcon style={{transform: "rotate(-180deg)"}}/>
                </IconButton>
            </div>
        }

        {!props.calendarAvailable && <div className={classes.headerDateInline}>
            {moment(selectedDate).format("MMMM YYYY")}
            {props.sessionsAreFiltred && <div className={classes.filterHeader}>
                {props.values.length > 0 && <>
                    <div> {moment(props.values[selectedSessionIndex]?.day).format("Do of MMM ")} </div>
                    <div> {selectedSessionIndex + 1}/{props.values.length} </div>
                   <div>
                       <IconButton
                           onClick={(e) => {setSelectedSessionIndex(selectedSessionIndex-1)}}
                           size="small"
                           disabled={selectedSessionIndex < 1}
                       >
                           <BackIcon/>
                       </IconButton>
                       <IconButton
                           onClick={(e) => {setSelectedSessionIndex(selectedSessionIndex+1)}}
                           size="small"
                           disabled={selectedSessionIndex >= props.values.length - 1}
                       >
                           <BackIcon  className={classes.rotate}/>
                       </IconButton>
                   </div>

                    <IconButton
                        onClick={openFilteredSessionModal}
                        size="small"
                    >
                        <AgyleListViewIcon />
                    </IconButton>
                </>}

                {props.values.length === 0 && <div> No matching </div>}

            </div>}
        </div>}

        <Grid container columns = {14} justifyContent={"center"}>
            {weekDays.map((day)=> (
                <Grid item xs={2} key={day}>
                    <div className={classes.dayNumber}>
                        <div className={classes.dayNumberPill}>{day}</div>
                    </div>
                </Grid>
            ))}
            {calendar.map((week, weekIndex) => {
                return week.map((day, dayIndex) => (
                  <Grid item xs={2} key={day.day} className={clsx(props.dayTileStyle && props.dayTileStyle(day, dayIndex))}>
                      <div style={{display: 'flex', justifyContent: 'center', flexGrow: 1}}>
                            <div onClick={() => handleDayClick(day)}
                                 className={clsx(props.dayClass, !day.actualMonth && props.dayOtherMonth, day.dayData?.length && props.selectedDayClass, day.actualMonth && dayIsFiltered(day.day) && classes.filteredDay)}>
                                {props.cardRender && props.cardRender(day, dayIndex, weekIndex)}
                                {!props.cardRender && renderDefaultDayCard(day)}
                            </div>
                        </div>

                    </Grid>
                ))
            })}
        </Grid>
    </div>)
}

export default AgyleCalendar

AgyleCalendar.propTypes = {
    cardRender: PropTypes.func,
    dayTileStyle: PropTypes.func,
    date: PropTypes.any,
    values: PropTypes.array,
    datePath: PropTypes.string,
    dayClass: PropTypes.string,
    selectedDayClass: PropTypes.string,
    dayOtherMonth: PropTypes.string,
    handleOnClick: PropTypes.func,
    calendarAvailable: PropTypes.bool,
    selectedDay: PropTypes.any
};

AgyleCalendar.defaultProps = {
    date: moment().startOf('month'),
    datePath: "day",
    calendarAvailable: true,
    dayOtherMonth: "dayOtherMonth"
};